import React from 'react';
import { Scale } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-400 py-10 border-t border-white/10" data-id="element-38">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-40">
          <div className="flex items-center gap-3" data-id="element-41">
            <Scale size={24} className="text-slate-600" data-id="element-42" />
            <div data-id="element-43">
              <h2 className="font-bold text-white tracking-tight" data-id="element-44">
                Правовий елемент
              </h2>
              <p className="text-[10px] uppercase tracking-wider text-slate-500" data-id="element-45">
                Адвокатське об'єднання
              </p>
            </div>
          </div>

          <div className="text-sm text-slate-500" data-id="element-46">
            <p data-id="element-47">© {new Date().getFullYear()} Всі права захищено.</p>
          </div>
        </div>
      </div>
    </footer>;
}